import React, { useState } from 'react';

const skillsWithProjects = [
  {
    name: 'React',
    icon: '⚛️',
    color: '#61DAFB',
    projects: [
      { name: 'IC Industries', link: 'https://icindustriesdev.pages.dev/' },
      { name: 'Satyrn VPN', link: 'https://satyrnvpn.pages.dev/' }
    ]
  },
  {
    name: 'Python',
    icon: '🐍',
    color: '#3776AB',
    projects: [
      { name: 'MrFish', link: 'https://github.com/Thymester/MrFish' },
      { name: 'System Resource Monitor', link: 'https://github.com/Thymester/System-Resource-Monitor' },
      { name: 'Image Revise', link: 'https://github.com/Thymester/ImageRevise/releases' }
    ]
  },
  {
    name: 'C#',
    icon: '🔷',
    color: '#239120',
    projects: [
      { name: 'SafeNotes', link: 'https://github.com/Thymester/SafeNotes' }
    ]
  },
  {
    name: 'JavaScript',
    icon: '🟨',
    color: '#F7DF1E',
    projects: [
      { name: 'IC Industries', link: 'https://icindustriesdev.pages.dev/' },
      { name: 'Satyrn VPN', link: 'https://satyrnvpn.pages.dev/' }
    ]
  },
  {
    name: 'TypeScript',
    icon: '🟦',
    color: '#3178C6',
    projects: [
      { name: 'Career Chronicles' }
    ]
  },
  {
    name: 'Lua',
    icon: '🌙',
    color: '#2C2D72',
    projects: [
      { name: 'SimpleMenu', link: 'https://github.com/Thymester/SimpleMenu' }
    ]
  }
];

function getRandomProject(projects) {
  return projects[Math.floor(Math.random() * projects.length)];
}

function OrbitingSkills() {
  const [hoveredSkill, setHoveredSkill] = useState(null);
  const [hoverTimeout, setHoverTimeout] = useState(null);

  const handleMouseEnter = (skill, project) => {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
    }
    setHoveredSkill({ skill, project });
  };

  const handleMouseLeave = () => {
    const timeout = setTimeout(() => {
      setHoveredSkill(null);
    }, 100);
    setHoverTimeout(timeout);
  };

  const handlePopupEnter = () => {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
    }
  };

  const handlePopupLeave = () => {
    setHoveredSkill(null);
  };

  return (
    <div className="orbiting-skills">
      {skillsWithProjects.map((skill, index) => {
        const angle = (index / skillsWithProjects.length) * 360;
        const randomProject = getRandomProject(skill.projects);

        return (
          <div
            key={skill.name}
            className="orbiting-skill"
            style={{
              '--angle': `${angle}deg`,
              '--color': skill.color,
              animationDelay: `${index * 0.5}s`
            }}
            onMouseEnter={() => handleMouseEnter(skill, randomProject)}
            onMouseLeave={handleMouseLeave}
          >
            <div className="skill-orb">
              <span className="skill-icon">{skill.icon}</span>
              <span className="skill-name">{skill.name}</span>
            </div>

            {hoveredSkill?.skill.name === skill.name && (
              <div
                className="project-popup"
                onMouseEnter={handlePopupEnter}
                onMouseLeave={handlePopupLeave}
              >
                <div className="project-info">
                  <p className="project-name">{hoveredSkill.project.name}</p>
                  {hoveredSkill.project.link && (
                    <a
                      href={hoveredSkill.project.link}
                      target="_blank"
                      rel="noreferrer"
                      className="project-link-btn"
                  >
                    View Project →
                  </a>
                  )}
              </div>
              </div>
            )}
    </div>
  );
      })}
    </div>
  );
}

export default OrbitingSkills;

